import { render, staticRenderFns } from "./PreviousOrderRefundInfo.vue?vue&type=template&id=498a1e41&"
import script from "./PreviousOrderRefundInfo.vue?vue&type=script&lang=ts&"
export * from "./PreviousOrderRefundInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports